"use client";

import { Placeholder } from "@lmn/design-system";
import styled from "styled-components";
import media from "@/styles/mediaQueries";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const FlexRow = styled.div`
  display: none;
  ${media.screenMdMin`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: space-between;
    align-items: flex-end;
  `}
`;

const AddressPlaceholder = styled.div`
  margin-bottom: 0.5rem;
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const DesktopOnlyButton = styled.div`
  display: none;
  ${media.screenMdMin`
    display: block;
  `}
`;

/* Mobile skeleton */
const MobileRows = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  ${media.screenMdMin`
    display: none;
  `}
`;

const MobileRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.kallisto.space.space100};
  padding: ${({ theme }) => theme.kallisto.space.space150} 0;
  border-top: 1px solid
    ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  min-width: 0;
  overflow: hidden;

  & > *:first-child {
    flex: 1;
    min-width: 0;
  }
`;

const MobileRowWithBorderBottom = styled(MobileRow)`
  border-bottom: 1px solid
    ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
`;

const MobileTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.kallisto.space.space100};
  margin-bottom: ${({ theme }) => theme.kallisto.space.space150};
  ${media.screenMdMin`
    display: none;
  `}
`;

export default function HotelTitleSkeleton() {
  return (
    <Container>
      {/* Mobile title + stars */}
      <MobileTitleRow>
        <Placeholder width="200px" height="32px" />
        <Placeholder width="100px" height="16px" />
      </MobileTitleRow>

      {/* Desktop title */}
      <div className="hidden-on-sm">
        <Placeholder width="320px" height="46px" />
      </div>

      {/* Desktop layout */}
      <FlexRow>
        <div>
          <AddressPlaceholder>
            <Placeholder width="240px" height="16px" />
          </AddressPlaceholder>
          <InfoContainer>
            <div>
              <Placeholder width="120px" height="16px" />
            </div>
            ·
            <div>
              <Placeholder width="40px" height="16px" />
            </div>
            ·
            <div>
              <Placeholder width="100px" height="16px" />
            </div>
          </InfoContainer>
        </div>
        <DesktopOnlyButton>
          <Placeholder variant="button" width="150px" />
        </DesktopOnlyButton>
      </FlexRow>

      {/* Mobile rows */}
      <MobileRows>
        <MobileRow>
          <InfoContainer>
            <Placeholder width="20px" height="20px" />
            <Placeholder width="200px" height="16px" />
          </InfoContainer>
          <Placeholder width="16px" height="16px" />
        </MobileRow>
        <MobileRowWithBorderBottom>
          <InfoContainer>
            <Placeholder width="32px" height="22px" />
            <Placeholder width="90px" height="16px" />
            <Placeholder width="100px" height="16px" />
          </InfoContainer>
          <Placeholder width="16px" height="16px" />
        </MobileRowWithBorderBottom>
      </MobileRows>
    </Container>
  );
}
